import LoadMoreInstances from "../utils/LoadMoreInstances.js";

class SiteSearch {
    constructor() {
        const allItems = document.querySelectorAll(`[data-cards-container] li`);

        if (!allItems) {
            return;
        }

        this.cardsContainer = document.querySelector(`[data-cards-container]`);

        this.radioFiltersContainers = document.querySelectorAll(
            `#search-filter-form [data-field-container]`,
        );

        this.radioFilters = document.querySelectorAll(
            `#search-filter-form input[name="type"]`,
        );

        this.filterContainer = document.querySelector(
            `[data-filters-container]`,
        );

        this.loadMoreBtn = document.getElementById("load-more-btn");

        // Cards
        this.eventCards = Array.from(allItems).filter((li) =>
            li.querySelector(`article.card--event`),
        );

        this.programmeCards = Array.from(allItems).filter((li) =>
            li.querySelector(`article.card--programme`),
        );

        this.everythingElseCards = Array.from(allItems).filter((li) =>
            li.querySelector(`article:not(.card--event):not(.card--programme)`),
        );

        // Result status
        this.resultStatusContainer =
            document.querySelector(`[data-result-status]`);

        this.howManyResult = this.resultStatusContainer.querySelector(
            `[data-how-many-result]`,
        );

        this.currentResults = -1;

        if (this.anyResult()) {
            this.displayResultStatus(true);

            this.setCurrentHowMany();

            this.updateHowManySpan();

            this.displayFilters(true);
        } else {
            this.displayResultStatus(false);

            this.displayFilters(false);
        }

        this.setTabsVisibility();

        this.handleFiltersChange();

        this.resetLoadMoreComponent();
    }

    anyResult() {
        return (
            this.eventCards?.length ||
            this.programmeCards?.length ||
            this.everythingElseCards.length
        );
    }

    resetLoadMoreComponent() {
        if (this.loadMoreBtn) {
            // Clone loadMore Btn, so the previous click event attached is removed.
            const loadMoreClone = this.loadMoreBtn.cloneNode(true);
            this.loadMoreBtn.remove();

            this.loadMoreBtn.replaceWith(loadMoreClone);

            this.loadMoreBtn.setAttribute("data-page-num", 1);

            // Insert load more btn.
            this.cardsContainer.after(this.loadMoreBtn);

            const loadMoreBtn = document.querySelector("[data-load-more-btn]");

            // Reload the LoadMoreInstances component.
            if (loadMoreBtn) {
                new LoadMoreInstances(loadMoreBtn);
            }
        }
    }

    handleFiltersChange() {
        this.radioFilters.forEach((radio) => {
            radio.addEventListener("change", () => {
                if (radio.checked) {
                    switch (radio.value) {
                        case "shows":
                            this.setCardsVisibility(["eventCards"], "show");

                            this.setCardsVisibility(
                                ["programmeCards", "everythingElseCards"],
                                "hide",
                            );
                            break;

                        case "programmes":
                            this.setCardsVisibility(["programmeCards"], "show");

                            this.setCardsVisibility(
                                ["eventCards", "everythingElseCards"],
                                "hide",
                            );
                            break;

                        default:
                            this.showAllCards();
                            break;
                    }

                    this.setCurrentHowMany();

                    this.updateHowManySpan();

                    this.setTabsVisibility();

                    this.resetLoadMoreComponent();
                }
            });
        });
    }

    setCardsVisibility(whichSet = [], action = "hide") {
        whichSet.forEach((cardSet) => {
            if (this[cardSet] && this[cardSet].length) {
                this[cardSet].forEach((card) => {
                    let hidden;

                    if (action == "hide") {
                        hidden = true;
                    } else {
                        hidden = false;
                    }

                    card.setAttribute("aria-hidden", hidden);
                });
            }
        });
    }

    setTabsVisibility() {
        let tabsMap = {
            showstab: this.eventCards?.length,
            programmestab: this.programmeCards?.length,
        };

        this.radioFiltersContainers?.forEach((div) => {
            let id = div.id;

            if (tabsMap[id] === 0) {
                div.setAttribute("aria-hidden", true);
            } else {
                div.setAttribute("aria-hidden", false);
            }
        });
    }

    setCurrentHowMany() {
        const visibleItems = document.querySelectorAll(
            `[data-cards-container] li[aria-hidden="false"]`,
        );

        this.currentResults = visibleItems?.length
            ? visibleItems?.length?.toString()
            : "";
    }

    updateHowManySpan() {
        if (this.howManyResult) {
            this.howManyResult.innerText = this.currentResults;
        }
    }

    showAllCards() {
        this.eventCards?.forEach((card) => {
            card.setAttribute("aria-hidden", false);
        });

        this.programmeCards?.forEach((card) => {
            card.setAttribute("aria-hidden", false);
        });

        this.everythingElseCards?.forEach((card) => {
            card.setAttribute("aria-hidden", false);
        });
    }

    displayResultStatus(display = false) {
        this.resultStatusContainer?.setAttribute("aria-hidden", !display);
    }

    displayFilters(display = false) {
        this.filterContainer?.setAttribute("aria-hidden", !display);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const isSearchPage = document.body.classList.contains("search");

    if (isSearchPage) {
        new SiteSearch();
    }
});
